import React, { useState, useContext } from 'react';
import Button from '../components/Buttons/Button';
import Card from '../components/Cards/Card';
import mod from './Pages.module.css';
import LoginForm from '../components/Forms/LoginForm';
import { Link } from 'react-router-dom';
import AuthContext from '../context/auth-context';

function LoginPage() {
	const authCtx = useContext(AuthContext);

	function downloadGame() {
		window.open(
			'https://www.dropbox.com/scl/fi/zcy8o4ad5pw1hb7qnqh3s/OMD-SP2.apk?rlkey=a8ndv9uon7btiwi55kh4oivs1&st=uleqq8sl&dl=0'
		);
	}

	return (
		<div className={mod.loginPage}>
			<Card className={mod.FormCard}>
				<h1>Login</h1>
				<LoginForm />
				<div className={mod.control}>
					<p>If you don't have an account just press here to create one</p>
					<Link to='/signup'>
						<Button className={mod.switchBtn}>Create new account</Button>
					</Link>
					{/* <Button className={mod.startBtn} onClick={downloadGame}>Download APK</Button> */}
				</div>
			</Card>
		</div>
	);
}

export default LoginPage;
